(function () {
  class SizeChartTabs extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('.size-chart-popup__tab-btn');
      this.panels = this.querySelectorAll('.size-chart-popup__panel');
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.setActive(btn.dataset.tab));
      });

      /* How to Measure buttons inside panels */
      this.querySelectorAll('.size-chart-popup__htm-btn').forEach((btn) => {
        btn.addEventListener('click', () => this.setActive(btn.dataset.tab));
      });

      const initialTab = this.dataset.activeTab || (this.buttons[0] && this.buttons[0].dataset.tab);
      this.setActive(initialTab);

      const tabsContainer = this.querySelector('.size-chart-popup__tabs');
      if (tabsContainer) {
        tabsContainer.addEventListener('scroll', () => this.updateTabsFadeState());
      }
      requestAnimationFrame(() => {
        this.scrollActiveTabIntoView(initialTab);
        this.updateTabsFadeState();
      });

      this.regionGroups = this.querySelectorAll('.size-chart-popup__region-tabs');
      this.regionGroups.forEach((group) => {
        const panel = group.closest('.size-chart-popup__panel');
        const regionButtons = group.querySelectorAll('.size-chart-popup__region-btn');
        regionButtons.forEach((btn) => {
          btn.addEventListener('click', () => this.setRegion(panel, regionButtons, btn.dataset.region));
        });
        this.setRegion(panel, regionButtons, 'au');
      });
    }
    updateTabsFadeState() {
      const container = this.querySelector('.size-chart-popup__tabs');
      const wrap = this.querySelector('.size-chart-popup__tabs-wrap');
      if (!container || !wrap) return;
      const atStart = container.scrollLeft <= 1;
      const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
      wrap.toggleAttribute('data-scroll-start', atStart);
      wrap.toggleAttribute('data-scroll-end', atEnd);
    }
    scrollActiveTabIntoView(tabKey) {
      const container = this.querySelector('.size-chart-popup__tabs');
      const target = Array.from(this.buttons).find((btn) => btn.dataset.tab === tabKey);
      if (!container || !target) return;
      const buffer = 12;
      const desiredScrollLeft = target.offsetLeft - buffer;
      container.scrollLeft = Math.max(0, desiredScrollLeft);
    }
    setActive(tabKey) {
      this.buttons.forEach((btn) => {
        const isActive = btn.dataset.tab === tabKey;
        btn.setAttribute('aria-selected', isActive);
      });
      this.panels.forEach((panel) => {
        if (panel.dataset.panel === tabKey) {
          panel.setAttribute('data-active', '');
        } else {
          panel.removeAttribute('data-active');
        }
      });
    }
    setRegion(panel, regionButtons, region) {
      regionButtons.forEach((btn) => {
        btn.setAttribute('aria-selected', btn.dataset.region === region);
      });
      panel.querySelectorAll('.size-chart-popup__row--region').forEach((row) => {
        if (row.dataset.region === region) {
          row.setAttribute('data-active', '');
        } else {
          row.removeAttribute('data-active');
        }
      });
      panel.querySelectorAll('td[data-au][data-us], th[data-au][data-us]').forEach((cell) => {
        cell.textContent = region === 'us' ? cell.dataset.us : cell.dataset.au;
      });
      panel.querySelectorAll('[data-au-text][data-us-text]').forEach((el) => {
        el.textContent = region === 'us' ? el.dataset.usText : el.dataset.auText;
      });
    }
  }
  if (!customElements.get('size-chart-tabs')) {
    customElements.define('size-chart-tabs', SizeChartTabs);
  }
})();